import { MinimumStationsGroup, Station } from '../../domain/stations';
import { DateTimeStr } from '../../types/date';
import { BaseAPIClient } from '../base_client';

export interface GenerateExportURLArgs {
  readonly stationId: string;
  readonly from: DateTimeStr;
  readonly to: DateTimeStr;
  readonly download?: boolean;
  readonly filename?: string;
}

export const StationsAPI = {
  fetchAll(this: BaseAPIClient): Promise<Station[]> {
    return this.get('/stations');
  },

  fetch(this: BaseAPIClient, idOrSlug: string): Promise<Station> {
    return this.get(`/stations/${idOrSlug}`);
  },

  save(this: BaseAPIClient, idOrSlug: string, data: Partial<Station>) {
    return this.put(`/stations/${idOrSlug}`, data);
  },

  fetchStationGroupsForStation(
    this: BaseAPIClient,
    idOrSlug: string,
  ): Promise<MinimumStationsGroup[]> {
    return this.get(`/stations-groups/stations/${idOrSlug}`);
  },

  fetchAllStationGroups(this: BaseAPIClient): Promise<MinimumStationsGroup[]> {
    return this.get('/stations-groups');
  },
};
